import { ElementType, useMemo } from 'react';
import { CgMenuLeft } from 'react-icons/cg';

import { useIconRepository } from '../../../../../contexts';
import { AccordionRadioGroupsSelecterItemTitleProps } from '../../AccordionRadioGroupsSelecter/types/AccordionRadioGroupsSelecterItemTitleProps';

export const useAccordionRadioGroupRenderableIcon = (
  icon: AccordionRadioGroupsSelecterItemTitleProps['icon'],
) => {
  const iconRepository = useIconRepository();
  const RenderableIcon = useMemo((): ElementType => {
    if (typeof icon === 'string') {
      if (icon in iconRepository) {
        return iconRepository[icon];
      }
    } else if (icon) {
      return icon;
    }

    return CgMenuLeft;
  }, [icon, iconRepository]);

  return RenderableIcon;
};
